/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Reasoning_Present_2Inputs */



/**
* | output |
* | --- |
* | "reasoning through it" |
*
* @param {Chat_Summary_Reasoning_Present_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_reasoning_present_2 = /** @type {((inputs?: Chat_Summary_Reasoning_Present_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Reasoning_Present_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("überlege")
	return /** @type {LocalizedString} */ ("reasoning through it")
});